import axios from "../../config/axiosConfig";
import {
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_REQUEST,
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS,
  PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_FAILURE,
} from "../types/purchase-grade-wise-rate-diff-report-types";

export const getPurchaseGradeWiseRateDiffReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      const data = requestParams; 

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Make API call
      return axios.post('/purchase-grade-wise-rate-diff-list/getPurchaseGradeWiseRateDiffReport', data, { params: defaultParams }).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS, payload: response?.data?.data });
          // dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error("Error fetching  Report:", error);
        dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching  Report:", error);
      dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_FAILURE, error: error.message });
    }
  };
};


export const getAllAccountOfPurchaseBillInGradeRateDiffList = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-grade-wise-rate-diff-list/getAllAccountOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const updateIsClosePurchaseGradeWiseRateDiff = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/purchase-grade-wise-rate-diff-list/update-is-close", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const clearPurchaseGradeWiseRateDiffReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_GRADE_WISE_RATE_DIFF_REPORT_SUCCESS, payload: {} });
  }
}
